export default {
  BASE_URL: '/admin/crm/feedback',
  api: [
    {
      name: 'status',
      desc: '获取处理状态下拉框',
      method: 'GET',
      path: '/status'
    },
    {
      name: 'result',
      desc: '获取处理结果下拉框',
      method: 'GET',
      path: '/result'
    },
    {
      name: 'list',
      desc: '获取反馈数据列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'detail',
      desc: '获取单个反馈详情',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'process',
      desc: '处理反馈',
      method: 'PUT',
      path: '/process'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/business/feedback.js